/*
********************************************************************************
TEMPORARY DATA FILE: Sample data and functions for app testing.  Will be 
replaced by actual API calls to NAVS in working app.
********************************************************************************
*/

//@ts-nocheck
// Toggle preceding from @ts-nocheck to @ts-check to enable TypeScript checking
import { consoleMsg } from "./utility.js";
import { carPlaceholders } from "./images.js";
import { PhotoManager } from "../classes/photo-manager.js";

// Make sure our app references are using the global app object associated with window
const app = window.app;

let combinedVehicleDetails = {};
// prettier-ignore
export { 
   combinedVehicleDetails, 
   updateCombinedVehicleDetails, 
   devModePhotosValidation, 
   updateDeliveryNotes,
   initializeAppData, 
};

function initializeAppData() {
	if (app.data && app.data.dataTables && Object.keys(app.data.dataTables).length) {
		const detectedVendor = app.data.dataTables["vehicle-info-table"]["Brand"];
		app.settings.vendor = detectedVendor;
		consoleMsg(`App initialized with ${detectedVendor} data`);
	} else {
		console.warn("No data found in app.data: vendor undefined and app state fallback to default flow. Check dummy-data-loader or backend integration.");
	}
}

async function updateCombinedVehicleDetails() {
	const storageKey = app.state.storageKey;
	const data = await store.get(`${storageKey}_vehicle-data`);
	const notes = app.data.deliveryNotes;
	if (data) {
		combinedVehicleDetails = {
			// Reassign the object
			vehicleInfo: data["vehicle-info-table"],
			contactInfo: data["contact-info-table"],
			loanInfo: data["loan-info-table"],
			deliveryNotes: notes,
		};
	}
	return combinedVehicleDetails;
}

function updateDeliveryNotes() {
	if (!app.data.deliveryNotes) {
		app.data.deliveryNotes = "No notes";
	}

	let notesDiv = document.getElementById("delivery-notes");
	if (notesDiv) {
		notesDiv.innerHTML = app.data.deliveryNotes;
	} else {
		console.warn("updateDeliveryNotes: Element with id='delivery-notes' not found in DOM");
	}
}

app.state.photoData = {
	"car-front": { src: carPlaceholders.carFront, updated: false },
	"car-driver-side": { src: carPlaceholders.carDriverSide, updated: false },
	"car-passenger-side": { src: carPlaceholders.carPassengerSide, updated: false },
	"car-back": { src: carPlaceholders.carBack, updated: false },
	"car-interior-front": { src: carPlaceholders.carInteriorFront, updated: false },
	"car-interior-rear": { src: carPlaceholders.carInteriorRear, updated: false },
	"car-vin": { src: carPlaceholders.carVin, updated: false },
	"car-top": { src: carPlaceholders.carTop, updated: false },
	"car-driver-profile": { src: carPlaceholders.carDriverProfile, updated: false },
	"car-passenger-profile": { src: carPlaceholders.carPassengerProfile, updated: false },
	"car-driver-rear-profile": { src: carPlaceholders.carDriverRearProfile, updated: false },
	"car-passenger-rear-profile": { src: carPlaceholders.carPassengerRearProfile, updated: false },
	"car-trunk": { src: carPlaceholders.carTrunk, updated: false },
	"car-odometer": { src: carPlaceholders.carOdomometer, updated: false },
};

// Dev mode function: toggles off validation of vehicle photos (IMPORTANT: REMOVE PRIOR TO GOING LIVE!!)
async function devModePhotosValidation() {
	// Start from whatever placeholders are already defined in app.state.photoData.
	// This guarantees key consistency (e.g., "car-front", "car-vin", etc.).
	const pd = app.state.photoData || {};
	const keys = Object.keys(pd);

	for (const key of keys) {
		// Try to restore a captured photo from Ionic Storage
		const stored = await store.get(key);
		if (stored && stored.photo) {
			// stored.photo is plain base64 (no prefix) — helper handles both plain and data URLs
			const blob = PhotoManager.base64ToBlob(stored.photo, "image/jpeg");
			pd[key] = { src: URL.createObjectURL(blob), updated: true };
			continue;
		}

		// If no stored photo but Dev Mode is on, keep your placeholder and mark as updated
		if (app.settings.isDevelopment === true) {
			pd[key] = { src: pd[key].src, updated: true };
		} else {
			// Non-dev: keep placeholder but do not mark as updated
			pd[key] = { src: pd[key].src, updated: false };
		}
	}

	app.state.photoData = pd;
}
